
  import * as awsAmplifyRuntime$pciTo5xYCDtnlWLTda4BMpQHLKy_45Dy5M5QQ4cIjsNEU from '/codebuild/output/src2379137541/src/ark/node_modules/@nuxt/image/dist/runtime/providers/awsAmplify'
import * as storyblokRuntime$CIZS80TknQ7_45Dx5YtgMFMKftZS5spDdb7PHmd1k93gs from '/codebuild/output/src2379137541/src/ark/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 420,
    "sm": 560,
    "md": 768,
    "lg": 1024,
    "xl": 1200,
    "xxl": 1536,
    "2xl": 1440
  },
  "presets": {},
  "provider": "awsAmplify",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 80
},
    providers: {
        ['awsAmplify']: { provider: awsAmplifyRuntime$pciTo5xYCDtnlWLTda4BMpQHLKy_45Dy5M5QQ4cIjsNEU, defaults: {} },
  ['storyblok']: { provider: storyblokRuntime$CIZS80TknQ7_45Dx5YtgMFMKftZS5spDdb7PHmd1k93gs, defaults: undefined }
    }
  }
